import React, { PropTypes } from "react";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import { UserItem } from "components/Admin/User/List/UserItem";

const titles = {
  numbering:"#",
  name: "NAME",
  email: "EMAIL",
};

class UsersPopupNewWebinar extends React.Component {

  userItemWebinar = (user, index) => (
    <tr key={user.id}>
      <td>{index + 1}</td>
      <td>
        {user.full_name || `${user.first_name} ${user.last_name}`}
      </td>
      <td>{user.email}</td>
    </tr>
  );

  render() {
    const {popupProps} = this.props;
    return (
      <div className="admin_user_table admin_table">
        <table>
          <tr>
            {Object.keys(titles).map(value => (
              <th key={value}>{titles[value]}</th>
            ))}
          </tr>
          {this.props.users.map((user, index) => this.userItemWebinar(user, index))}
        </table>
        {popupProps && (popupProps.type === "attended" || popupProps.type === "viewed" )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  popupProps: state.modal.modalContentProps.additional
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersPopupNewWebinar);



// WEBPACK FOOTER //
// ./src/containers/Admin/Webinar/UsersPopupNewWebinar.js